export {default} from './Mentors.connect';
